export default __webpack_public_path__ + "img/historical.3987f210.jpg";